// src/realtime/ChatReactions.js
import React from "react";
import "./ChatReactions.css";

const REACTIONS = ["💜", "✨", "🌟", "🪐", "💖"];

function ChatReactions({ onSendReaction, incomingReactions = [] }) {
  const handleClick = (emoji) => {
    if (onSendReaction) {
      onSendReaction(emoji);
    }
  };

  return (
    <div className="chat-reaction-container">
      {/* Boutons en bas à droite du panel */}
      <div className="chat-reaction-buttons">
        {REACTIONS.map((emo) => (
          <button
            key={emo}
            type="button"
            onClick={() => handleClick(emo)}
            className="chat-reaction-btn"
          >
            {emo}
          </button>
        ))}
      </div>

      {/* Réactions synchronisées (toi + l’autre) */}
      {incomingReactions.map((r) => (
        <div
          key={r.id}
          className="chat-floating-reaction"
          style={{
            left: `${Math.random() * 60 + 10}%`, // un peu aléatoire pour le fun
          }}
        >
          {r.emoji}
        </div>
      ))}
    </div>
  );
}

export default ChatReactions;
